// @ts-nocheck
// Menu Configuration - Based on HTML Menu Structure
import { 
  Star, Grid, Chrome, FileText, Lock, Airplay,
  Building2, Handshake, User, MapPin, CreditCard, Hash, Wrench, FileCheck, Package,
  ShoppingBag, Banknote, Ruler, UserCheck, Building, UserCog,
  Truck, Map, Anchor, FileSpreadsheet, Calculator, ShoppingCart, Nut,
  ClipboardList, Receipt, Ticket, RefreshCw, RotateCcw, Fuel, PieChart, TicketCheck,
  DollarSign, Calendar, Ship, TrendingUp, Search, Mail, MessageSquare, Settings, LayoutDashboard,
  Droplets, Gauge, Zap, Wallet, CheckCircle2, Sparkles, AlertTriangle, ShieldCheck, MailWarning, Clock, Moon } from 'lucide-react';
import { APP_ROUTES } from '../app/routePaths';

export const menuConfig = [
  {
    category: 'FAVOURITES',
    icon: Star,
    items: [
      { name: 'Sales Order', icon: FileText, path: APP_ROUTES.saleOrder },
      { name: 'Incident Report', icon: AlertTriangle, path: APP_ROUTES.irReportNew },
      { name: 'Job Order', icon: Wrench, path: APP_ROUTES.jobOrderNew },
      { name: 'Quotation', icon: DollarSign, path: '/Quotation' },
      { name: 'Sales Invoice', icon: Receipt, path: '/SaleInvoice' },
      { name: 'Planning', icon: Calendar, path: APP_ROUTES.planning, screenKey: 'planning' },
      { name: 'Vessel Planning', icon: Ship, path: APP_ROUTES.vesselPlanning },
      { name: 'RTI', icon: TrendingUp, path: APP_ROUTES.rti },
      
      { name: 'Pre Alert Report', icon: FileText, path: APP_ROUTES.preAlertReport }
    ]
  },
  {
    category: 'MASTER',
    icon: Grid,
    subCategories: [
      {
        name: 'Sales Master',
        items: [
          { name: 'Company', icon: Building2, path: '/CompanySetting' },
          { name: 'Agent Company Master', icon: Handshake, path: '/AgentCompanyMaster' },
          { name: 'Agent Master', icon: User, path: '/AgentMaster' },
          { name: 'Address Master', icon: MapPin, path: '/AddressMaster' },
          { name: 'PaymentTerms Master', icon: CreditCard, path: '/PaymentTermsMaster' },
          { name: 'Symbol Master', icon: Hash, path: '/SymbolMaster' },
          { name: 'JobType Master', icon: Wrench, path: '/JobTypeMaster' },
          { name: 'JobType Details', icon: FileCheck, path: '/JobTypeDetails' },
          { name: 'JobStatus Master', icon: TrendingUp, path: '/JobStatusMaster' },
          { name: 'JobStatus Details', icon: FileCheck, path: '/JobStatusDetails' },
          { name: 'Item Master', icon: Package, path: '/ItemMaster' },
          { name: 'Product Master', icon: ShoppingBag, path: '/ProductMaster' },
          { name: 'Tax Master', icon: Banknote, path: '/TaxMaster' },
          { name: 'UOM', icon: Ruler, path: '/UOMMaster' },
          { name: 'Customer', icon: UserCheck, path: '/CustomerMaster' },
          { name: 'Payment Receipt', icon: Receipt, path: '/paymentReceiptInfo' },
          { name: 'Customer Quotation', icon: DollarSign, path: '/CustomerQuotation' },
          { name: 'Supplier', icon: Building, path: '/SupplierMaster' },
          { name: 'HR Dashboard', icon: LayoutDashboard, path: APP_ROUTES.hrDashboard },
          { name: 'Employee Master', icon: UserCog, path: APP_ROUTES.employeeMaster },
          { name: 'Driver Master', icon: Truck, path: '/DriverMaster' },
          { name: 'Truck Master', icon: Truck, path: '/TruckMaster' },
          { name: 'Location Master', icon: Map, path: '/LocationMaster' },
          { name: 'Port Master', icon: Anchor, path: '/PortMaster' },
          { name: 'PaymentReceiptInfo', icon: FileSpreadsheet, path: '/PaymentReceiptInfo' }
        ]
      },
      {
        name: 'Accounts Master',
        items: [
          { name: 'Bank Master', icon: Building2, path: '/BankMaster' },
          { name: 'Expense Master', icon: Calculator, path: '/ExpenseMaster' },
          { name: 'Sub Expense Master', icon: Calculator, path: '/SubExpenseMaster' },
          { name: 'Chart of Accounts', icon: FileSpreadsheet, path: '/AccountsGroupMaster' }
        ]
      }
    ]
  },
  {
    category: 'TRANSACTION',
    icon: Chrome,
    subCategories: [
      {
        name: 'Sales',
        items: [
          { name: 'Sales Order', icon: FileText, path: APP_ROUTES.saleOrder },
          { name: 'Incident Report', icon: AlertTriangle, path: APP_ROUTES.irReportNew },
          { name: 'Quotation', icon: DollarSign, path: '/Quotation' },
          { name: 'Sales Invoice', icon: Receipt, path: '/SaleInvoice' },
          { name: 'Planning', icon: Calendar, path: APP_ROUTES.planning, screenKey: 'planning' },
          { name: 'Vessel Planning', icon: Ship, path: APP_ROUTES.vesselPlanning },
          { name: 'RTI', icon: TrendingUp, path: APP_ROUTES.rti },
          // Customer Service's forwarding requests (K1/K2/K3/K8), worked by the forwarding team.
          { name: 'Forwarding Requests', icon: ClipboardList, path: APP_ROUTES.forwardingRequests },
          { name: 'My Forwarding Requests', icon: ClipboardList, path: APP_ROUTES.myForwardingRequests },
          { name: 'Job Order', icon: Wrench, path: APP_ROUTES.jobOrderView },
          { name: 'Employee Assignments', icon: TrendingUp, path: APP_ROUTES.employeeAssignments },
          { name: 'ENQUIRY', icon: Search, path: '/EnquiryMaster' },
          { name: 'ENQUIRYTR', icon: Search, path: '/EnquiryMaster/EnquiryMasterTR' }
        ]
      },
      {
        name: 'Accounts',
        items: [
          { name: 'Accounts Dashboard', icon: LayoutDashboard, path: '/dashboard/accounts' }
        ],
        subCategories: [
          {
            name: 'Receivable',
            items: [
              { name: 'Receivable Dashboard', icon: LayoutDashboard, path: APP_ROUTES.accountsReceivable },
              { name: 'Receipt', icon: Receipt, path: APP_ROUTES.receipt },
              { name: 'Sale Credit Note', icon: FileText, path: '/SaleCredit' }
            ]
          },
          {
            name: 'Payable',
            items: [
              { name: 'Pending Payments', icon: Calculator, path: '/PaymentVoucher/PaymentPending' },
              { name: 'Sub Expense Contracts', icon: Calculator, path: '/Accounts/SubExpenseContracts' },
              { name: 'Period Lock', icon: Calculator, path: '/Accounts/PeriodLock' }
            ]
          },
          {
            name: 'Payable Reports',
            items: [
              { name: 'Payables Ageing', icon: FileText, path: '/Accounts/Reports/PayablesAgeing' },
              { name: 'Vendor Outstanding', icon: FileText, path: '/Accounts/Reports/VendorOutstanding' },
              { name: 'Hire Purchase Loans', icon: FileText, path: '/Accounts/Reports/HirePurchase' },
              { name: 'Payment Register', icon: FileText, path: '/Accounts/Reports/PaymentRegister' },
              { name: 'Payable Exceptions', icon: FileText, path: '/Accounts/Reports/PayableExceptions' }
            ]
          }
        ]
      }
    ],
    items: [
      { name: 'EmailInbox', icon: Mail, path: '/EmployeeMaster/EmployeeMailData' },
      { name: 'GoogleReview', icon: MessageSquare, path: '/EmployeeMaster/GoogleReview' }
    ]
  },
  {
    category: 'TRANSPORT',
    icon: Truck,
    items: [
      { name: 'Transport Dashboard', icon: LayoutDashboard, path: APP_ROUTES.transportDashboard },
      { name: 'Ongoing Job View', icon: FileSpreadsheet, path: APP_ROUTES.transportOngoingJobView },
      { name: 'Truck Location Board', icon: MapPin, path: APP_ROUTES.truckLocationBoard }
    ]
  },
  {
    category: 'WORKSHOP',
    icon: Wrench,
    items: [
      { name: 'Inventory', icon: Package, path: APP_ROUTES.inventory },
      { name: 'Recon', icon: RotateCcw, path: APP_ROUTES.recon }
    ]
  },
  {
    category: 'CRYSTAL REPORT',
    icon: FileText,
    subCategories: [
      {
        name: 'Master Reports',
        items: [
          { name: 'Address Report', icon: MapPin, path: '/Report/AddressReport' },
          { name: 'Agent Report', icon: User, path: '/Report/AgentReport' },
          { name: 'Item Report', icon: Package, path: '/Report/ItemReport' },
          { name: 'Product Report', icon: ShoppingBag, path: '/Report/ProductReport' },
          { name: 'Truck Report', icon: Truck, path: '/Report/TruckReport' },
          { name: 'Driver Report', icon: Truck, path: '/Report/DriverReport' },
          { name: 'Employee Report', icon: UserCog, path: '/Report/EmployeeReport' }
        ]
      },
      {
        name: 'Transaction Master',
        items: [
          { name: 'Pre Alert Report', icon: FileText, path: APP_ROUTES.preAlertReport },
          { name: 'Expense Report', icon: Calculator, path: '/Report/ExpenseReport' },
          { name: 'Renewal Report', icon: RefreshCw, path: '/Report/RenewalReport' },
          { name: 'Salary Report', icon: Banknote, path: '/Report/SalaryReport' },
          { name: 'Driver RTI Report', icon: Truck, path: '/Report/DriverRTIReport' },
          { name: 'Payment Voucher Report', icon: Receipt, path: '/Report/PaymentVoucherReport' },
          { name: 'Toll Voucher Report', icon: Ticket, path: '/Report/TollReport' },
          { name: 'Fuel Report', icon: Fuel, path: '/Report/FuelReport' }
        ]
      },
      {
        name: 'Sales Report',
        items: [
          { name: 'Sale Consolidate', icon: FileText, path: '/Report/SaleReport' },
          { name: 'Sale Detail Report', icon: FileText, path: '/Report/SaleDetailedReport' },
          { name: 'SaleCredit Report', icon: FileText, path: '/Report/SaleCreditReport' },
          { name: 'SaleCredit Detailed Report', icon: FileText, path: '/Report/SaleCreditDetailedReport' }
        ]
      },
      {
        name: 'Supplier Report',
        items: [
          { name: 'Supplier List', icon: Building, path: '/Report/SupplierReport' },
          { name: 'Supplier Balance', icon: Calculator, path: '/Report/SupplierBalance' },
          { name: 'Supplier Payments', icon: Receipt, path: '/Report/SupplierPayment' },
          { name: 'Supplier Payments Due Report', icon: FileText, path: '/Report/SupplierPaymentDue' },
          { name: 'Supplier Statement', icon: FileSpreadsheet, path: '/Report/SupplierStatement' }
        ]
      },
      {
        name: 'Purchase Report',
        items: [
          { name: 'Purchase Report', icon: ShoppingCart, path: '/Report/PurchaseReport' },
          { name: 'Purchase Detail Report', icon: FileText, path: '/Report/PurchaseDetailedReport' },
          { name: 'Purchase History', icon: FileSpreadsheet, path: '/Report/PurchaseItemWiseReport' },
          { name: 'Bills Report', icon: Receipt, path: '/Report/BillsReport' },
          { name: 'Bills Detailed Report', icon: FileText, path: '/Report/BillsDetailedReport' },
          { name: 'Bills Accountwise Report', icon: FileSpreadsheet, path: '/Report/BillItemWiseReport' }
        ]
      },
      {
        name: 'Customer Report',
        items: [
          { name: 'Customer List', icon: UserCheck, path: '/Report/CustomerReport' },
          { name: 'Customer Statement', icon: FileSpreadsheet, path: APP_ROUTES.customerStatement },
          { name: 'Customer Balance', icon: Calculator, path: APP_ROUTES.customerBalanceReport },
          { name: 'Customer Ageing', icon: FileText, path: APP_ROUTES.customerAgeingReport },
          { name: 'Customer Receipt', icon: Receipt, path: APP_ROUTES.customerReceiptReport },
          { name: 'Customer Receipt Due', icon: FileText, path: APP_ROUTES.customerReceiptDueReport },
          { name: 'Customer Quotation', icon: FileText, path: APP_ROUTES.customerQuotationReport }
        ]
      }
    ]
  },
  {
    category: 'UTILS',
    icon: Lock,
    items: [
      { name: 'Main Setting', icon: Settings, path: '/Mainsetting' },
      { name: 'AI Settings', icon: Sparkles, path: APP_ROUTES.aiSettings },
      // Shown to the Super Admin only (see filterMenuForAccess).
      { name: 'Screen Access', icon: ShieldCheck, path: APP_ROUTES.screenAccess, superAdminOnly: true },
      // Unread company mail. The Super Admin sees every mailbox (live); a team leader their team's
      // mailboxes (openspec mail-monitor-team-leaders). The server enforces both.
      { name: 'Mailbox Monitor', icon: MailWarning, path: APP_ROUTES.mailMonitor, superAdminOnly: true, teamLeadersToo: true },
      // How fast each mailbox replies (Super Admin only; the server enforces it too).
      { name: 'Mail Response Report', icon: Clock, path: APP_ROUTES.mailResponseReport, superAdminOnly: true },
      // Mail received and sent between 7 pm and 8 am (Super Admin only).
      { name: 'After-hours Mail', icon: Moon, path: APP_ROUTES.mailAfterHours, superAdminOnly: true }
    ]
  },
  {
    category: 'PAYABLE',
    icon: Airplay,
    items: [
      { name: 'Spare Parts', icon: Nut, path: '/PurchaseMaster' },
      { name: 'PURCHASE ORDER', icon: ClipboardList, path: '/BillsOrderMaster' },
      { name: 'Bills', icon: Receipt, path: '/bills/new' },
      { name: 'Pay Bills', icon: Banknote, path: '/Payment' },
      { name: 'Claim Voucher', icon: Ticket, path: '/ClaimVoucher' },
      { name: 'Expense Entry', icon: Calculator, path: '/ExpenseEntry' },
      { name: 'Renewal Entry', icon: RefreshCw, path: '/RenewalEntry' },
      { name: 'Salary Entry', icon: Banknote, path: '/SalaryEntry' },
      { name: 'Fuel Entry', icon: Fuel, path: '/FuelEntry' },
      { name: 'GPS Fuel Fillings', icon: Droplets, path: APP_ROUTES.gpsFuelFillings },
      { name: 'GPS Engine Hours', icon: Gauge, path: APP_ROUTES.gpsEngineHours },
      { name: 'GPS Speed Report', icon: Zap, path: APP_ROUTES.gpsSpeedReport },
      { name: 'Toll Entry', icon: Ticket, path: APP_ROUTES.tollEntry },
      { name: 'Levi Entry', icon: PieChart, path: APP_ROUTES.leviEntry },
      { name: 'AutoPass Entry', icon: Ticket, path: APP_ROUTES.autoPassEntry },
      { name: 'Payment Voucher', icon: TicketCheck, path: APP_ROUTES.paymentVoucher },
      { name: 'Payment Completed', icon: CheckCircle2, path: APP_ROUTES.paymentVoucherCompleted },
      { name: 'Petty Cash', icon: Wallet, path: APP_ROUTES.pettyCash }
    ]
  }
];
